<template>
    <div>
        <div class="news_details_title">
            <span>{{info.title}}</span>
            <small>{{info.addtime}}</small>
        </div>
        <div class="news_details_text" v-html="info.content"></div>
    </div>
</template>

<script>
import api from '@/request/api.js'
export default {
    data() {
        return {
            info: {}, // 详情信息
        }
    },
    methods: {
        getInfo () { // 获取订单详情
            this.http.post(api.newsdetails, {id: this.$route.params.id})
            .then(response => {
                // console.log(response.data.msg)
                this.info = response.data.msg.info
            })
            .catch(error => {
                console.log(error);
            })
        }
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/news/_news.vue